<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/pegawai-list-custom">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Pensiun
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>Daftar Pensiun</h5>
    </div>

    <LogPopupTemplate ref="logPopup" />
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="pegawaiListStore.dataSourcePegawaiPensiunList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing($event)"
        >
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
          />
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxColumnFixing :enabled="true" />
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="id"
            data-type="number"
            caption="Opsi"
            :allow-exporting="false"
            :allow-edititng="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="getOptions(data)"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
          <!-- <DxColumn
            caption="pegawaiID"
            data-field="pegawai_id"
            data-type="number"
            :visible="false"
          /> -->

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />
          <DxColumn
            data-type="string"
            data-field="nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="simpeg_pegawais_nama"
            caption="Nama"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
            :min-width="200"
          >
          </DxColumn>

          <DxColumn
            dataField="status_aktifs_nama"
            caption="Status Aktif"
            :allowHeaderFiltering="false"
            :header-filter="{ dataSource: commonStore.statusAktifSource }"
            :allow-filtering="false"
            :allow-sorting="false"
          />

          <DxColumn
            data-type="string"
            data-field="nik_ktp"
            caption="No. KTP"
            :allowHeaderFiltering="false"
          >
          </DxColumn>
          <DxColumn
            data-type="string"
            data-field="simpeg_pegawais_email"
            caption="Email"
            :allowHeaderFiltering="false"
          >
          </DxColumn>
          <DxColumn
            data-type="string"
            data-field="telp"
            caption="No. Telp"
            :allowHeaderFiltering="false"
          >
          </DxColumn>
          <DxColumn
            data-field="jenis_kelamin"
            caption="L/P"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.jenisKelaminSource }"
          />
          <DxColumn
            data-field="umur_pegawai"
            caption="Umur"
            data-type="number"
            :allowHeaderFiltering="false"
            :calculate-filter-expression="calculateFilterExpressionUmur"
            :filter-operations="filterOperations"
          />
          <DxColumn
            data-field="ptkp"
            caption="PTKP"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.statusPtkpSource }"
          />
          <DxColumn
            data-field="simpeg_pegawais_tgl_mulai_bekerja"
            caption="Tgl Mulai Bekerja"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          />

          <!-- <DxColumn
            data-field="ter"
            caption="TER PPH 21 (%)"
            :allowHeaderFiltering="false"
            data-type="number"
          />
          -->

          <DxColumn
            data-field="tgl_lahir"
            caption="Tgl Lahir"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          />
          <DxColumn
            data-field="pensiun_tgl"
            caption="Tgl Pensiun"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
            sort-order="desc"
          />
          <DxColumn
            data-field="golongans_nama"
            caption="Gol."
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.getGolonganSource().value,
            }"
          />

          <!-- <DxColumn
            data-field="simpeg_kgbs_masa_kerja"
            caption="Masa Kerja Tahun (KGB)"
            :allowHeaderFiltering="false"
            :customize-text="commonFunction.appendTahun"
          /> -->
          <DxColumn
            data-field="simpeg_pegawais_tgl_mulai_bekerja"
            caption="Masa Kerja (Thn)"
            :allowHeaderFiltering="false"
            :customize-text="commonFunction.appendTahun"
            :calculate-filter-expression="calculateFilterExpressionMK"
            cell-template="showMK"
            :filter-operations="filterOperations"
          />

          <DxColumn
            data-field="masa_kerja_bulan"
            :allow-filtering="false"
            :allow-sorting="false"
            caption="Masa Kerja (Bln)"
            :allowHeaderFiltering="false"
            :customize-text="commonFunction.appendBulan"
          />

          <template #showMK="{ data }">
            {{ data.data.masa_kerja_tahun + " Tahun" }}
          </template>

          <!-- <DxColumn
            data-field="simpeg_kgbs_masa_kerja_bulan"
            caption="Masa Kerja Bulan (KGB)"
            :allowHeaderFiltering="false"
            :customize-text="commonFunction.appendBulan"
          /> -->

          <DxColumn
            data-field="cabangs_nama"
            caption="Cabang"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.cabangSource }"
          />
          <DxColumn
            data-field="units_nama"
            caption="Unit"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.unitSource }"
          />

          <DxColumn
            data-field="pegawai_statuses_nama"
            caption="Status Pegawai"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.pegawaiStatusSource }"
          />
          <DxColumn
            data-field="jabatans_nama"
            caption="Jabatan"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.jabatanSource }"
          />
          <DxColumn
            data-field="status_jabatan"
            caption="Status Jabatan"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.statusJabatanSource }"
          />

          <DxColumn
            data-field="bagians_nama"
            caption="Bagian"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.bagianSource }"
          />
          <DxColumn
            data-field="sub_bagians_nama"
            caption="Sub Bagian"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.subBagianSource }"
          />
          <DxColumn
            data-field="bidangs_nama"
            caption="Bidang"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.bidangSource }"
          />
          <DxColumn
            data-field="sub_bidangs_nama"
            caption="Sub Bidang"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.subBidangSource }"
          />
          <DxColumn
            data-field="seksis_nama"
            caption="Seksi"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.seksiSource }"
          />
          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import * as commonFunction from "@/utils/common-function.js";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import { DateTime } from "luxon";
// import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";

/* eslint-disable */
export default {
  components: {
    LogPopupTemplate,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
  },
  setup() {
    const pegawaiListStore = usePegawaiListStore();
    // pegawaiListStore.dataSourcePegawaiList.filter([
    //   "status_aktifs_nama",
    //   "=",
    //   "Pensiun",
    // ]);
    const commonStore = useCommonStore();

    return {
      commonFunction,
      pegawaiListStore,
      commonStore,
    };
  },
  data() {
    const vm = this;
    return {
      logPopupRef: null,
      filterOperations: ["=", "<>", ">", "<", "between"],
      filterValue: [],

      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
      calculateFilterExpressionMK: function (
        filterValue,
        selectedFilterOperation,
        target,
      ) {
        var colFilter = "simpeg_pegawais_tgl_mulai_bekerja";
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let filterExpression = [];
          if (filterValue == 0) {
            filterExpression.push([colFilter, "=", null]);
          } else {
            filterExpression.push(
              [colFilter, "<=", vm.calculateDateFromAge(filterValue)],
              "and",
              [
                colFilter,
                ">",
                vm.calculateDateFromAge(parseInt(filterValue) + 1),
              ],
            );
          }
          return filterExpression;
        }

        if (selectedFilterOperation === ">" && target == "filterRow") {
          let filterExpression = [
            colFilter,
            "<",
            vm.calculateDateFromAge(parseInt(filterValue) + 1),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          let filterExpression = [
            colFilter,
            "<>",
            vm.calculateDateFromAge(parseInt(filterValue)),
          ];
          return filterExpression;
        }

        if (selectedFilterOperation === "<" && target == "filterRow") {
          let filterExpression = [
            colFilter,
            ">",
            vm.calculateDateFromAge(filterValue),
          ];
          return filterExpression;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          if (typeof filterValue === "string") {
            let coba = filterValue
              .split(",")
              .map((part) => Number(part.trim()));

            filterValue = coba;
          }
          const minAge = filterValue[0];
          const maxAge = filterValue[1];
          if (minAge !== undefined && maxAge !== undefined) {
            return [
              [colFilter, ">", vm.calculateDateFromAge(parseInt(maxAge) + 1)], // Using '<' to include the exact date of birth
              "and",
              [colFilter, "<", vm.calculateDateFromAge(minAge)],
            ];
          } else if (minAge !== undefined) {
            return [colFilter, "<", vm.calculateDateFromAge(minAge)];
          } else if (maxAge !== undefined) {
            return [
              colFilter,
              ">",
              vm.calculateDateFromAge(parseInt(maxAge) + 1),
            ];
          } else {
            return null; // Return null to indicate that no filter should be applied
          }
        }
      },

      calculateFilterExpressionUmur: function (
        filterValue,
        selectedFilterOperation,
        target,
      ) {
        var colFilter = "tgl_lahir";
        if (selectedFilterOperation === "=" && target == "filterBuilder") {
          let filterExpression = [];
          if (filterValue == 0) {
            filterExpression.push([colFilter, "=", null]);
          } else {
            filterExpression.push(
              [colFilter, "<=", vm.calculateDateFromAge(filterValue)],
              "and",
              [
                colFilter,
                ">",
                vm.calculateDateFromAge(parseInt(filterValue) + 1),
              ],
            );
          }
          return filterExpression;
        }

        if (selectedFilterOperation === ">" && target == "filterBuilder") {
          let filterExpression = [
            colFilter,
            "<",
            vm.calculateDateFromAge(parseInt(filterValue) + 1),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterBuilder") {
          let filterExpression = [
            colFilter,
            "<>",
            vm.calculateDateFromAge(parseInt(filterValue)),
          ];
          return filterExpression;
        }

        if (selectedFilterOperation === "<" && target == "filterBuilder") {
          let filterExpression = [
            colFilter,
            ">",
            vm.calculateDateFromAge(filterValue),
          ];
          return filterExpression;
        }

        if (
          selectedFilterOperation === "between" &&
          target == "filterBuilder"
        ) {
          if (typeof filterValue === "string") {
            let coba = filterValue
              .split(",")
              .map((part) => Number(part.trim()));

            filterValue = coba;
          }
          const minAge = filterValue[0];
          const maxAge = filterValue[1];
          if (minAge !== undefined && maxAge !== undefined) {
            return [
              [colFilter, ">", vm.calculateDateFromAge(parseInt(maxAge) + 1)], // Using '<' to include the exact date of birth
              "and",
              [colFilter, "<", vm.calculateDateFromAge(minAge)],
            ];
          } else if (minAge !== undefined) {
            return [colFilter, "<", vm.calculateDateFromAge(minAge)];
          } else if (maxAge !== undefined) {
            return [
              colFilter,
              ">",
              vm.calculateDateFromAge(parseInt(maxAge) + 1),
            ];
          } else {
            return null; // Return null to indicate that no filter should be applied
          }
        }
      },
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {
    // await this.commonStore.preloadStores();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    getOptions(data) {
      return [
        {
          text: "Detail Pegawai",
          pegawai_id: data.data.id,
          row_key: data.key,
        },
        {
          text: "Absensi",
          pegawai_id: data.data.id,
          row_key: data.key,
        },
        {
          text: "Riwayat Gaji",
          pegawai_id: data.data.id,
          row_key: data.key,
        },
        {
          text: "Log Perubahan Data",
          pegawai_id: data.data.id,
          row_key: data.key,
        },
        // other options...
      ];
    },
    calculateDateFromAge(age) {
      const today = DateTime.local();
      return today.minus({ years: age }).toJSDate();
    },
    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    onContextMenuPreparing(e) {
      console.log("onContextMenuPreparing", e);
      if (e.target == "content") {
        e.itemData = {
          pegawai_id: e.row.data.id,
          row_key: e.row.data.id,
        };

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];
        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          onItemClick: () => {
            e.itemData.text = "Detail Pegawai";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Lihat Absensi",
          icon: "event",
          onItemClick: () => {
            e.itemData.text = "Absensi";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Riwayat Gaji",
          icon: "money",
          onItemClick: () => {
            e.itemData.text = "Riwayat Gaji";
            this.onItemClick(e);
          },
        });
        e.items.push({
          text: "Log Perubahan Data",
          icon: "clock",
          onItemClick: () => {
            e.itemData.text = "Log Perubahan Data";
            this.$refs.logPopup.showAll("pegawai", e.row.key);
          },
        });
      }
    },
    onItemClick(e) {
      console.log("hello", e);
      const pegawaiId = e.itemData.pegawai_id;
      const rowKey = e.itemData.row_key;

      if (e.itemData.text === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: {
            filter: ["absen_bulans_pegawai_id", "=", pegawaiId],
          },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Log Perubahan Data") {
        this.$refs.logPopup.showAll("pegawai", pegawaiId);
      }
    },
    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      // exportDataGrid({
      //   component: e.component,
      //   worksheet,
      //   autoFilterEnabled: true,
      // }).then(() => {
      //   workbook.xlsx.writeBuffer().then((buffer) => {
      //     saveAs(
      //       new Blob([buffer], { type: "application/octet-stream" }),
      //       "Daftar Pegawai.xlsx"
      //     );
      //   });
      // });

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,

        // 👇 This is where we customize cell export
        customizeCell({ gridCell, excelCell }) {
          // Check for the specific column
          if (
            gridCell.column?.dataField === "simpeg_pegawais_tgl_mulai_bekerja"
          ) {
            // Use masa_kerja_tahun instead
            const mk = gridCell.data?.masa_kerja_tahun;
            if (mk !== undefined) {
              excelCell.value = `${mk} Tahun`;
            }
          }
        },
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pegawai Pensiun.xlsx",
          );
        });
      });

      e.cancel = true;
    },
  },
};
</script>
